import React from "react";
import "./loading.component.css";

function LoadingComponent({
  size = 50,
  color = "#1D3557",
  speed = 1200,
  shape = "spinner", // 'circle', 'square', or 'spinner'
  message = "",
  isLoading = true,
  backdrop = false,
  addStyle = {},
  spinnerWidth = 5,
  messageStyle = "",
}) {
  if (!isLoading) return null;

  const spinnerColorAndType = (shape) => {
    const baseStyler = {
      bgColor: "transparent",
      animation: "spin",
    };

    switch (shape) {
      case "spinner":
        return {
          ...baseStyler,
          bdColor: `${color} ${color} transparent`,
        };
      case "spinner_2":
        return {
          ...baseStyler,
          bdColor: `${color} transparent ${color} transparent`,
        };
      case "spinner_3":
        return {
          ...baseStyler,
          bdColor: `${color} transparent transparent transparent`,
        };
      default:
        return {
          bdColor: `${color} transparent ${color} transparent`,
          bgColor: color,
          animation: "pulse",
        };
    }
  };

  const spinnerStyle = {
    width: size + "px",
    height: size + "px",
    borderWidth: spinnerWidth + "px",
    backgroundColor: spinnerColorAndType(shape).bgColor,
    borderColor: spinnerColorAndType(shape).bdColor,
    animation: `${
      spinnerColorAndType(shape).animation
    } ${speed}ms linear infinite`,
    ...addStyle,
  };

  return (
    <div className={`loading-spinner-wrapper ${backdrop ? "backdrop" : ""}`}>
      <div className={`loading-spinner ${shape}`} style={spinnerStyle}></div>
      {message && (
        <span className={`loading-message ${messageStyle} text-[${color}]`}>
          {message}
        </span>
      )}
    </div>
  );
}

export default LoadingComponent;
